import GifPicker from './gif-picker'
import React, {PropTypes} from 'react'
import Strings from 'config/strings'

const CardForm = React.createClass({

  propTypes: {
    onSubmit: PropTypes.func.isRequired
  },

  getInitialState() {
    return {
      title  : '',
      gif    : ''
    }
  },

  render() {
    let { title, gif } = this.state

    return (
      <form className="card-form" onSubmit={ this.onSubmit }>
        <label className="hide-visually" htmlFor="card_title">Card Title</label>
        <input className="card-form__title"
               ref="title"
               id="card_title"
               name="title"
               placeholder={ Strings['cards.title.placeholder'] }
               value={ title }
               autoComplete="off"
               onChange={ this.onTitleChange } />

        <GifPicker selected={ gif } term={ title } onSelect={ this.onGifChange }/>

        <input disabled={ !title } className="card-form__submit" type="submit" value={ Strings['cards.add'] } />
      </form>
    )
  },

  onGifChange(gif) {
    this.setState({ gif })
  },

  onTitleChange(e) {
    var title = e.target.value

    this.setState({ title, gif: '' })
  },

  onSubmit(e) {
    e.preventDefault()

    this.props.onSubmit({
      card: {
        gif   : this.state.gif,
        title : this.state.title
      }
    })

    this.setState({ title: '', gif: '' })
    this.refs.title.focus();
  }

})


export default CardForm



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/card-form.jsx
 **/